export const valueHasPAN = (() => {
    // Check PAN through Luhn, adapted from https://gist.github.com/2134376
    const luhnCheck = (value: string | number) => {
        const stringValue = value.toString().replace(/\D/g, '');
        let nCheck = 0;
        let bEven = false;
        if (stringValue.length < 12 || stringValue.length > 19) return false;

        for (let n = stringValue.length - 1; n >= 0; n--) {
            const cDigit = stringValue.charAt(n);
            let nDigit = parseInt(cDigit, 10);

            const condition = bEven && (nDigit *= 2) > 9;
            if (condition) nDigit -= 9;

            nCheck += nDigit;
            bEven = !bEven;
        }

        return nCheck % 10 === 0;
    };
    return luhnCheck;
})();
